export default __webpack_public_path__ + "static/media/634c83c904aa4a9757fe8bee698616a01600266163156.1fbefda2.webp";